import {
  AppAction,
  ResponseMessage,
  ErrorMessage,
  ErrorMessageValue,
  RequestMessage,
  SDKAction,
} from '../types/actions';
import { Context, ReverseProxyData } from './types';

class InitializeRequest extends RequestMessage {
  value: undefined;

  constructor() {
    super(AppAction.SDK_INITIALIZE);
  }
}

class InitializeResponse extends ResponseMessage {
  value: { context: Context; reverseProxyData: ReverseProxyData };

  constructor(
    uuid: string,
    context: Context,
    reverseProxyData: ReverseProxyData
  ) {
    super(AppAction.SDK_INITIALIZE, uuid, { context, reverseProxyData });
  }
}

class InitializeError extends ErrorMessage {
  constructor(uuid: string, value: ErrorMessageValue) {
    super(AppAction.SDK_INITIALIZE, uuid, value);
  }
}

class GetAddonInfoRequest extends RequestMessage {
  value: undefined;

  constructor() {
    super(SDKAction.SDK_GET_ADDON_INFO);
  }
}

class GetAddonInfoResponse extends ResponseMessage {
  value: { title: string };

  constructor(uuid: string, title: string) {
    super(SDKAction.SDK_GET_ADDON_INFO, uuid, { title });
  }
}

class GetAddonInfoError extends ErrorMessage {
  constructor(uuid: string, value: ErrorMessageValue) {
    super(SDKAction.SDK_GET_ADDON_INFO, uuid, value);
  }
}

class AuthorizeRequest extends RequestMessage {
  value: undefined;

  constructor() {
    super(AppAction.SDK_AUTHORIZE);
  }
}

class AuthorizeResponse extends ResponseMessage {
  value: { reverseProxyData: ReverseProxyData };

  constructor(uuid: string, reverseProxyData: ReverseProxyData) {
    super(AppAction.SDK_AUTHORIZE, uuid, { reverseProxyData });
  }
}

class AuthorizeError extends ErrorMessage {
  constructor(uuid: string, value: ErrorMessageValue) {
    super(AppAction.SDK_AUTHORIZE, uuid, value);
  }
}

export {
  InitializeRequest,
  InitializeResponse,
  InitializeError,
  GetAddonInfoRequest,
  GetAddonInfoResponse,
  GetAddonInfoError,
  AuthorizeRequest,
  AuthorizeResponse,
  AuthorizeError,
};
